// Central SEO defaults for the static marketing pages.
//
// These are the fallback <title>/<meta description> used when the admin has NOT
// overridden them. Overrides live in admin_config.seo and reach the frontend via
// /public-config (cfg.seo[path]). The admin editor (AdminSeo.jsx) lists exactly
// the routes below, and the <Seo> component resolves override → default.
//
// ChecksHub, blog posts, checker landings, theme-intent and business profiles are
// intentionally NOT here: their title/description come from their own content.

export const SEO_PAGES = [
  {
    path: "/",
    label: "Home",
    title: "CheckExpert — laat je document doorlichten in 60 seconden",
    description:
      "Huurcontract, polis, loonstrook of energiecontract? CheckExpert toont in 60 seconden de risico's en bespaart je honderden euro's. €4,99 per check, GDPR-conform.",
  },
  {
    path: "/hoe-het-werkt",
    label: "Hoe het werkt",
    title: "Hoe het werkt — je document laten checken in 60 seconden | CheckExpert",
    description:
      "Upload je document, CheckExpert analyseert het en toont in 60 seconden de belangrijkste risico's. Ontdek stap voor stap hoe het werkt.",
  },
  {
    path: "/prijzen",
    label: "Prijzen",
    title: "Prijzen — vanaf €4,99 per check | CheckExpert",
    description:
      "Bekijk de tarieven van CheckExpert: één document laten doorlichten vanaf €4,99, of voordeliger met een creditbundel. Geen abonnement, GDPR-conform.",
  },
  {
    path: "/over-ons",
    label: "Over ons",
    title: "Over ons — de mensen achter CheckExpert",
    description:
      "CheckExpert maakt juridische en financiële documenten begrijpelijk voor iedereen in België en Nederland. Lees ons verhaal en onze aanpak.",
  },
  {
    path: "/contact",
    label: "Contact",
    title: "Contact — CheckExpert",
    description:
      "Vragen over een check of over je document? Neem contact op met CheckExpert. We helpen je snel verder — voor particulieren en bedrijven in België en Nederland.",
  },
  {
    path: "/faq",
    label: "FAQ",
    title: "Veelgestelde vragen (FAQ) | CheckExpert",
    description:
      "Antwoorden op de meest gestelde vragen over CheckExpert: hoe een check werkt, prijzen, privacy en betaling. Voor België en Nederland.",
  },
  {
    path: "/blog",
    label: "Blog",
    title: "Blog — tips over contracten, polissen en documenten | CheckExpert",
    description:
      "Praktische artikelen over huurcontracten, verzekeringen, loonstroken en meer. Leer waar je op moet letten met CheckExpert.",
  },
  {
    path: "/voor-bedrijven",
    label: "Voor bedrijven",
    title: "Voor bedrijven — word partner van CheckExpert",
    description:
      "Bied je klanten documentchecks aan of word partner van CheckExpert. Ontdek de mogelijkheden voor bedrijven in België en Nederland.",
  },
];

export const SEO_DEFAULTS = Object.fromEntries(
  SEO_PAGES.map((p) => [p.path, { title: p.title, description: p.description }])
);
